export default __webpack_public_path__ + "static/media/instructions.5559eecb.jpg";